// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { createAxios } from 'ts/createAxios';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import {
  ProcessingMaster,
  ProcessingMasterParams,
} from 'util/processingMasterType';

export const getProcessingMaster = async (params: {
  materialName: string;
  successCallback?: (data: ProcessingMaster[]) => void;
}) => {
  const { materialName, successCallback } = params;
  const api = createAxios();

  try {
    const { data } = await api.get<ProcessingMaster[]>(
      API_ENDPOINTS.PROCESSING_MASTERS,
      {
        params: {
          materialName,
        },
      }
    );

    successCallback?.(data);
  } catch (error) {
    handleError(error);
  }
};

export const updateProcessingMaster = async (
  params: ProcessingMasterParams,
  successCallback?: () => void
) => {
  const api = createAxios();
  try {
    await api.post(API_ENDPOINTS.PROCESSING_MASTERS, params);

    successCallback?.();
  } catch (error) {
    handleError(error);
  }
};
